import { render, staticRenderFns } from "./TransferHistoryItem.vue?vue&type=template&id=9305b866&scoped=true"
import script from "./TransferHistoryItem.vue?vue&type=script&lang=js"
export * from "./TransferHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./TransferHistoryItem.vue?vue&type=style&index=0&id=9305b866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9305b866",
  null
  
)

export default component.exports